/* global navigator*/
export default class ImageCompare {

    constructor(params, callback) {
        this.video = params.video;
        this.canvas = params.canvasIn;
        this.canvas0 = params.canvasTmp;
        this.canvas2 = params.canvasOut;
        this.callback = callback;
    }

    async capture() {
        const constraints = {
            audio: false,
            video: true
        };
        this.stream = await navigator.mediaDevices.getUserMedia(constraints).catch((err) => { alert(err) });
        this.video.srcObject = this.stream;
        this.run();
    }

    run() {
        
        let timeOut, imgFirst, img0, img1, img2;
        setInterval(() => {
            this.canvas.width = this.video.videoWidth;
            this.canvas.height = this.video.videoHeight;
            this.canvas.getContext('2d').drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
            let first = false;
            if (!img1) {
                img1 = this.canvas.getContext('2d').getImageData(0, 0, this.canvas.width, this.canvas.height);
                first = true;
            }
            else {
                if (img2) {
                    img0 = img1;
                    img1 = img2;
                }
                img2 = this.canvas.getContext('2d').getImageData(0, 0, this.canvas.width, this.canvas.height);
            }
            let res = 0;
            if (img1 && img2) {
                res = this.compare(img1, img2);
            }

            if (res > 0.4 && res <= 1) {
                if (!imgFirst) {
                    imgFirst = img0;
                    //this.canvas0.getContext('2d').drawImage(video, 0, 0, this.canvas.width, this.canvas.height);
                    this.canvas0.getContext('2d').putImageData(imgFirst, 0, 0);
                }
                else {
                    let res2 = this.compare(imgFirst, img2);
                    console.log('compare2', res2)
                    if (res2 > 1)
                        res = res2;
                }
            }

            if (res > 1 || first) {
                if (timeOut) {
                    clearTimeout(timeOut);
                }
                timeOut = setTimeout(() => {
                    console.log('create image');
                    imgFirst = false;
                    this.canvas2.width = this.video.videoWidth;
                    this.canvas2.height = this.video.videoHeight;
                    this.canvas2.getContext('2d').drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
                    this.callback(this.canvas2.toDataURL('image/jpeg', 1.0))
                }, 1600)
            }

        }, 500);
    }

    compare(img1, img2) {
        var diff = 0;

        for (var i = 0; i < img1.data.length / 4; i++) {
            diff += Math.abs(img1.data[4 * i + 0] - img2.data[4 * i + 0]) / 255;
            diff += Math.abs(img1.data[4 * i + 1] - img2.data[4 * i + 1]) / 255;
            diff += Math.abs(img1.data[4 * i + 2] - img2.data[4 * i + 2]) / 255;
        }

        let res = (100 * diff / (img1.width * img1.height * 3));
        return res;
    }

}



// WEBPACK FOOTER //
// ./src/Sdk/ImageCompare.js